import React from "react";
import { AppointmentWrapper } from "@widgets/appointment/ui/appointment-wrapper/appointment-wrapper";

export const Appointment = () => {
  return (
		<AppointmentWrapper/>
	)
};
